// extracted by mini-css-extract-plugin
export default {"collapsibleContentWrapper":"AlertEventExpandableText_collapsibleContentWrapper__+QqnH","actionsMargin":"AlertEventExpandableText_actionsMargin__edWKz"};